angular.module('stack.common.utility.services.StringService', [])

/**
 * The StringService service stores utility methods that
 * manage the manipulation of strings.
 *
 * @class StringService
 * @constructor
 * @module stack.common.utility.services.StringService
 */
.factory('StringService', [
  function () {
    'use strict';

    var service = {
      /**
       * Method takes a string and capitalizes the first initial.
       *
       * @param {string} str - String to initialCap
       */
      initialCap: function initialCap(str) {
        return _.capitalize(str);
      }
    };

    return service;
  }
]);
